let active = false

export function setRevolutCheckoutActive(value) {
  active = value
}

// Shared by both desktop/mobile countdowns. A redirect can arrive before the
// app-level checkout component mounts, so protect its stored session immediately.
export function isRevolutCheckoutActive() {
  if (active) return true
  try {
    const params = new URL(window.location.href).searchParams
    if (params.get('revolutPaymentReturn') !== '1') return false
    if (/^[1-9]\d*$/.test(params.get('revolutAttempt') || '') &&
      /^[a-f0-9]{64}$/i.test(params.get('revolutReturnToken') || '')) return true
    const checkout = JSON.parse(window.sessionStorage.getItem('revolut-pay-checkout') || 'null')

    const isSdkCheckout = checkout && checkout.provider === 'REVOLUT' &&
      checkout.checkoutType === 'REVOLUT_PAY' && Number.isSafeInteger(checkout.attemptId) &&
      checkout.statusToken && checkout.orderToken && checkout.publicKey

    return !!isSdkCheckout
  } catch (error) {
    return false
  }
}
